/* eslint-disable @typescript-eslint/no-explicit-any */

import {
    ApiRequestInit,
    type DeleteRequest,
    type GetRequest,
    type PostRequest,
    type RequestResult,
    type UpdateRequest,
} from '../../structs';
import { makeQueryParams } from '../utils/query';

import { makeRequest } from './makeRequest';
import { makeUrl } from './makeUrl';

// TODO - move these requests to /requests & update imports
export async function getRequest<T>({
    target,
    query = {},
    customQuery = '',
    token,
    resourceId,
    settings,
    prefetch,
    apiSettingsType = 'yat',
}: GetRequest): RequestResult<T> {
    const queryParams = customQuery || makeQueryParams(query);
    const url = `${makeUrl({ settings, apiSettingsType })}${target}${queryParams}`;
    const req = new Request(url, {
        ...ApiRequestInit,
        credentials: settings && settings.credentials ? settings.credentials : undefined,
    });
    return makeRequest<T>({ req, token, resourceId, settings, prefetch, apiSettingsType });
}

export async function postRequest<T>({
    target,
    value,
    query = {},
    token,
    resourceId,
    settings,
    prefetch,
    additionalHeaders,
    apiSettingsType = 'yat',
}: PostRequest): RequestResult<T> {
    const queryParams = makeQueryParams(query);
    const headers: Headers = new Headers(ApiRequestInit.headers);
    additionalHeaders?.forEach((value, key) => {
        headers.set(key, value);
    });

    const req = new Request(`${makeUrl({ settings, apiSettingsType })}${target}${queryParams}`, {
        ...ApiRequestInit,
        ...{
            headers,
            method: 'POST',
            body: JSON.stringify(value),
            credentials: settings && settings.credentials ? settings.credentials : undefined,
        },
    });

    return makeRequest<T>({ req, token, resourceId, settings, prefetch, apiSettingsType });
}

export async function patchRequest<T>({
    target,
    value,
    query = {},
    resourceId,
    token,
    settings,
    prefetch,
    apiSettingsType = 'yat',
}: UpdateRequest): RequestResult<T> {
    const queryParams = makeQueryParams(query);
    const req = new Request(`${makeUrl({ settings, apiSettingsType })}${target}${queryParams}`, {
        ...ApiRequestInit,
        ...{
            method: 'PATCH',
            body: JSON.stringify(value),
            credentials: settings && settings.credentials ? settings.credentials : undefined,
        },
    });

    return makeRequest<T>({ req, token, resourceId, settings, prefetch, apiSettingsType });
}

export async function putRequest<T>({
    target,
    value,
    query = {},
    resourceId,
    token,
    settings,
    prefetch,
    apiSettingsType = 'yat',
}: UpdateRequest): RequestResult<T> {
    const queryParams = makeQueryParams(query);
    const req = new Request(`${makeUrl({ settings, apiSettingsType })}${target}${queryParams}`, {
        ...ApiRequestInit,
        ...{
            method: 'PUT',
            body: JSON.stringify(value),
            credentials: settings && settings.credentials ? settings.credentials : undefined,
        },
    });

    return makeRequest<T>({ req, token, resourceId, settings, prefetch, apiSettingsType });
}

export async function deleteRequest<T>({
    target,
    query = {},
    token,
    value,
    resourceId,
    settings,
    prefetch,
    apiSettingsType = 'yat',
}: DeleteRequest): RequestResult<T> {
    const queryParams = makeQueryParams(query);
    const req = new Request(`${makeUrl({ settings, apiSettingsType })}${target}${queryParams}`, {
        ...ApiRequestInit,
        ...{
            method: 'DELETE',
            body: value ? JSON.stringify(value) : undefined,
        },
    });

    return makeRequest<T>({ req, token, resourceId, settings, prefetch, apiSettingsType });
}
